export const uploadImage = (file, cancelToken) => (
  (dispatch, getState, api) => {
    const formData = new window.FormData()
    formData.append('image', file)

    return api({
      method: 'post',
      apiPath: 'upload',
      data: formData,
      headers: { 'Content-Type': file.type },
      cancelToken
    })
  }
)
